import styled from 'styled-components';
const AddMemberStyled = styled.div`
  padding: 0 24px;
  background-color: #fff;
  .box {
    width: 540px;
    .MuiTextField-root {
      width: 100%;
    }
    .single-select {
      width: 100%;
    }
  }
  .buttonWrap {
    padding: 40px ${(props) => props.theme.spacing(3)};
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export default AddMemberStyled;
